// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3zhMB","header":"Messages_header__11dnK"};